import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { dealQueryKeys } from '@crm/entities/deal';
import { projectApi } from '@crm/entities/project';
import { toastManager } from '@crm/entities/toast';
import { getApiErrorMessage } from '@crm/shared/api';

import type { TDeal } from '@crm/entities/deal';

export const useCreateProjectMutation = ({ dealId }: { dealId: TDeal['id'] }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: projectApi.createProject,
        onSuccess: (dealDetailsData) => {
            queryClient.setQueryData(dealQueryKeys.detail(dealId), dealDetailsData);
        },
        onError: (error) => {
            toastManager.onError({
                duration: 5000,
                title: getApiErrorMessage(
                    error,
                    t('crm.dealDetailsPage.errors.createProject')
                ),
            });
        },
    });
};
